export const useIsUrlWhiteboardCompetitor = (url: string) => {
	const competitors = [
		{ name: 'Miro', domains: ['miro.com'] },
		{ name: 'Mural', domains: ['mural.co'] },
		{ name: 'Lucid', domains: ['lucid.co'] },
		{ name: 'Microsoft Whiteboard', domains: ['whiteboard.office.com', 'wbd.ms'] },
		{ name: 'Figjam', domains: ['figma.com/board'] },
		{ name: 'Google Jamboard', domains: ['jamboard.google.com'] }, // Note: Google Jamboard is EOL
		{ name: 'Excalidraw', domains: ['excalidraw.com'] },
		{ name: 'Klaxoon', domains: ['klaxoon.com'] },
	];

	const competitor = competitors.find((competitor) =>
		competitor.domains.some((domain) => {
			const regex = new RegExp(domain, 'i');
			return regex.test(url);
		}),
	);

	return {
		competitorName: competitor?.name,
	};
};
